import React, { ReactElement } from 'react';
import { Strip } from '../../Models/Article';
import './SpacerStrip.scss';

interface SpacerStripProps {
    strip: Strip;
}

export function SpacerStrip({ strip: { params } }: SpacerStripProps): ReactElement {
    // @todo define type
    const { height } = params as { height: number };
    return <div className='SpacerStrip' style={{ height }} />;
}
